import { hasAnyPermission, isAuthenticated } from "../utils/authUtils";
import { Navigate } from "react-router-dom";

export default function PermissionRoute({ permissions, children }) {
    if (!isAuthenticated()) return <Navigate to="/login" />;
    if (!hasAnyPermission(permissions)) return <Navigate to="/unauthorized" />;
    return children;
}
